import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Scan, Users, Store, Globe, Truck, BrainCircuit } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function WhyBoaiPage() {
  const navigate = useNavigate();

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">
        <section id="features" className="features-section">
          <div className="container">
            <h2 className="section-title">Why Choose BoAI?</h2>
            <p className="section-subtitle">क्यों चुनें BoAI?</p>
            <p className="features-intro">Unlike competitors who stop at diagnosis, BoAI delivers the complete outcome — from detection to treatment to market access.</p>

            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon"><Scan size={32} /></div>
                <h3>Outcome-Driven Diagnosis</h3>
                <p className="hindi-text">परिणाम-आधारित निदान</p>
                <p>Not just identification — AI diagnosis coupled with expert consultation, treatment plans, and product recommendations to solve the problem end-to-end</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><Users size={32} /></div>
                <h3>Expert Consultations</h3>
                <p className="hindi-text">विशेषज्ञ परामर्श</p>
                <p>Physically connecting farmers with agronomists — reducing the digital barrier that stops rural adoption of technology</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><Store size={32} /></div>
                <h3>Agri Commerce</h3>
                <p className="hindi-text">कृषि वाणिज्य</p>
                <p>Built-in marketplace for seeds, pesticides, fertilizers — product discovery and price discovery in one place</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><Globe size={32} /></div>
                <h3>Unified AI Platform</h3>
                <p className="hindi-text">एकीकृत AI मंच</p>
                <p>AI crop diagnosis, weather alerts, soil analysis, market prices, and community — all integrated services on a single platform</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><Truck size={32} /></div>
                <h3>Supply Chain Bridge</h3>
                <p className="hindi-text">आपूर्ति श्रृंखला सेतु</p>
                <p>Eliminating middlemen exploitation — connecting farmers directly to bulk buyers for fair prices and zero wastage</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><BrainCircuit size={32} /></div>
                <h3>Future-Ready Tech</h3>
                <p className="hindi-text">भविष्य-तैयार तकनीक</p>
                <p>Pioneering Hyperspectral Imaging, Small Language Models for agriculture, and AI voice agents — technology no one else is building</p>
              </div>
            </div>

            <div className="page-cta-bar">
              <button className="btn-primary" onClick={() => navigate('/auth')}>
                Get Started with BoAI
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
